const setServiceList = (state, serviceList) => {
  state.serviceList = serviceList;
};

export default {
  setServiceList
};



// WEBPACK FOOTER //
// ./src/store/modules/services/mutations.js